<script setup>
import Causer from '@/Components/Models/ActivityLog/Causers/User.vue'
import { defineAsyncComponent } from 'vue'
import { computed } from 'vue'
import { useErrorsStore } from '@/Stores/errors'
const errors = useErrorsStore()

const props = defineProps({
	item: {
		type: Object,
		required: true,
	},
});

// this model has polymorphic relationships to multiple models, so we'll need to resolve the subject to a component within the @/Components/Models/ActivityLog/Subjects folder
const AsyncComp = defineAsyncComponent(() => {
	switch (props.item.subject_type) // attendee, booking, event, loggedjob, organisation, user
	{
		case 'attendee':
			return import('@/Components/Models/ActivityLog/Subjects/Attendee.vue')
		case 'booking':
			return import('@/Components/Models/ActivityLog/Subjects/Booking.vue')
		case 'event':
			return import('@/Components/Models/ActivityLog/Subjects/Event.vue')
		case 'loggedjob':
			return import('@/Components/Models/ActivityLog/Subjects/LoggedJob.vue')
		case 'organisation':
			return import('@/Components/Models/ActivityLog/Subjects/Organisation.vue')
		case 'user':
			return import('@/Components/Models/ActivityLog/Subjects/User.vue')
		default:
			errors.push({
				title: 'Unknown subject type',
				message: 'The subject type "' + props.item.subject_type + '" is not recognised. Please contact support.',
				type: 'error',
			})

	}

})

</script>

<template>
	<Causer :item="item.causer" />

	<AsyncComp :item="item" />
</template>